import React, { lazy } from "react";
import { Routes, Route, Brow } from "react-router-dom";
import Loader from "../components/loader/index";
import { ProtectedMemberRoute, ProtectedAdminRoute } from "./protectedRoute";

const EventList = lazy(() => import("../pages/event/eventList"));
const Contact = lazy(() => import("../components/contacts/Contact"));
const EventDetail = lazy(() => import("../pages/event/eventDetail"));
const Conversations = lazy(() => import("../pages/conversations/index"));
const Challenges = lazy(() => import("../pages/challenges/index"));
const Accountibility = lazy(() => import("../pages/accountibility/index"));
const Marketing = lazy(() => import("../pages/marketing/marketing-tools"));
const CroudSorcedMarketing = lazy(() => import("../pages/marketing/index"));
const MemberLeaderBoard = lazy(() =>
  import("../pages/leaderboard/memberLeaderboard")
);
const HostLeaderBoard = lazy(() =>
  import("../pages/leaderboard/hostLeaderboard")
);
const TopHostLeaderBoard = lazy(() =>
  import("../pages/leaderboard/topLeaderboard")
);
const Users = lazy(() => import("../pages/user"));
const Magazine = lazy(() => import("../pages/magazine"));
// const MemberDashboard = lazy(() =>
//   import("../pages/MemberPages/dashboard/Dashboard")
// );
const Notifications = lazy(() => import("../pages/notifications"));
const MyMembers = lazy(() => import("../pages/myMembers"));
const Admins = lazy(() => import("../pages/admins"));
const Home = lazy(() => import("../pages/home"));
const Applications = lazy(() => import("../pages/hosts"));

const AdminRoutes = () => {
  return (
    <React.Suspense fallback={<Loader />}>
      <Routes>
        <Route
          path="/home"
          element={
            <ProtectedMemberRoute>
              <Home />
            </ProtectedMemberRoute>
          }
        />
        <Route path="/event" element={<EventList />} />
        <Route path="/event/:id" element={<EventDetail />} />
        <Route path="/magazines" element={<Magazine />} />
        <Route
          path="/chat"
          element={
            // <ProtectedMemberRoute>
            <Conversations />
            // </ProtectedMemberRoute>
          }
        />
        <Route path="/challenges" element={<Challenges />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/accountibility"
          element={
            <ProtectedMemberRoute>
              <Accountibility />
            </ProtectedMemberRoute>
          }
        />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/crowdsourced" element={<CroudSorcedMarketing />} />
        <Route
          path="/users"
          element={
            <ProtectedAdminRoute>
              <Users />
            </ProtectedAdminRoute>
          }
        />
        <Route
          path="/applications"
          element={
            <ProtectedAdminRoute>
              <Applications />
            </ProtectedAdminRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedAdminRoute>
              <Notifications />
            </ProtectedAdminRoute>
          }
        />
        <Route
          path="/admins"
          element={
            <ProtectedAdminRoute>
              <Admins />
            </ProtectedAdminRoute>
          }
        />
        <Route path="/member-leaderboard" element={<MemberLeaderBoard />} />
        <Route path="/host-leaderboard" element={<HostLeaderBoard />} />
        <Route path="/top-host-leaderboard" element={<TopHostLeaderBoard />} />
        <Route path="/my-members" element={<MyMembers />} />
        {/* <Route
          path="/*"
          element={
            <ProtectedMemberRoute>
              <MemberDashboard />
            </ProtectedMemberRoute>
          }
        /> */}
      </Routes>
    </React.Suspense>
  );
};

export default AdminRoutes;
